import { render, staticRenderFns } from "./BaseUI.vue?vue&type=template&id=72b497a7&scoped=true&"
import script from "./BaseUI.vue?vue&type=script&lang=js&"
export * from "./BaseUI.vue?vue&type=script&lang=js&"
import style0 from "./BaseUI.vue?vue&type=style&index=0&id=72b497a7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b497a7",
  null
  
)

export default component.exports